import { render, staticRenderFns } from "./OrderProduct.vue?vue&type=template&id=0d2bff50&scoped=true&"
import script from "./OrderProduct.vue?vue&type=script&lang=js&"
export * from "./OrderProduct.vue?vue&type=script&lang=js&"
import style0 from "./OrderProduct.vue?vue&type=style&index=0&id=0d2bff50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2bff50",
  null
  
)

export default component.exports